module.exports = __webpack_public_path__ + "img/rectangle-ad.3464b042.svg";